/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelDiscountDto } from './FunnelDiscountDto';
import {
    FunnelDiscountDtoFromJSON,
    FunnelDiscountDtoFromJSONTyped,
    FunnelDiscountDtoToJSON,
    FunnelDiscountDtoToJSONTyped,
} from './FunnelDiscountDto';

/**
 * 
 * @export
 * @interface FunnelPricingDto
 */
export interface FunnelPricingDto {
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    brokerCommission: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    priceExcludingTax: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    feesSum?: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    priceIncludingTax: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    clientPrice: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    monthlyPriceIncludingTax?: number;
    /**
     * Monthly price
     * @type {number}
     * @memberof FunnelPricingDto
     */
    monthPrice?: number;
    /**
     * Yearly price
     * @type {number}
     * @memberof FunnelPricingDto
     */
    yearPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    totalPriceEightYears?: number;
    /**
     * 
     * @type {number}
     * @memberof FunnelPricingDto
     */
    averageRate?: number;
    /**
     * 
     * @type {FunnelDiscountDto}
     * @memberof FunnelPricingDto
     */
    discount?: FunnelDiscountDto;
}

/**
 * Check if a given object implements the FunnelPricingDto interface.
 */
export function instanceOfFunnelPricingDto(value: object): value is FunnelPricingDto {
    if (!('brokerCommission' in value) || value['brokerCommission'] === undefined) return false;
    if (!('priceExcludingTax' in value) || value['priceExcludingTax'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('priceIncludingTax' in value) || value['priceIncludingTax'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    return true;
}

export function FunnelPricingDtoFromJSON(json: any): FunnelPricingDto {
    return FunnelPricingDtoFromJSONTyped(json, false);
}

export function FunnelPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerCommission': json['brokerCommission'],
        'priceExcludingTax': json['priceExcludingTax'],
        'tax': json['tax'],
        'feesSum': json['feesSum'] == null ? undefined : json['feesSum'],
        'priceIncludingTax': json['priceIncludingTax'],
        'clientPrice': json['clientPrice'],
        'monthlyPriceIncludingTax': json['monthlyPriceIncludingTax'] == null ? undefined : json['monthlyPriceIncludingTax'],
        'monthPrice': json['monthPrice'] == null ? undefined : json['monthPrice'],
        'yearPrice': json['yearPrice'] == null ? undefined : json['yearPrice'],
        'totalPriceEightYears': json['totalPriceEightYears'] == null ? undefined : json['totalPriceEightYears'],
        'averageRate': json['averageRate'] == null ? undefined : json['averageRate'],
        'discount': json['discount'] == null ? undefined : FunnelDiscountDtoFromJSON(json['discount']),
    };
}

export function FunnelPricingDtoToJSON(json: any): FunnelPricingDto {
    return FunnelPricingDtoToJSONTyped(json, false);
}

export function FunnelPricingDtoToJSONTyped(value?: FunnelPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerCommission': value['brokerCommission'],
        'priceExcludingTax': value['priceExcludingTax'],
        'tax': value['tax'],
        'feesSum': value['feesSum'],
        'priceIncludingTax': value['priceIncludingTax'],
        'clientPrice': value['clientPrice'],
        'monthlyPriceIncludingTax': value['monthlyPriceIncludingTax'],
        'monthPrice': value['monthPrice'],
        'yearPrice': value['yearPrice'],
        'totalPriceEightYears': value['totalPriceEightYears'],
        'averageRate': value['averageRate'],
        'discount': FunnelDiscountDtoToJSON(value['discount']),
    };
}

